module.exports = __webpack_public_path__ + "img/noClass.a355004e.png";